'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@petsmart-ui/sparky';
import { usePathname, useSearchParams } from 'next/navigation';
import { ReactElement, useCallback } from 'react';
import { AccountDrawerType } from '../types/pageLayout';
import { getAuth0LoginRedirectOptions } from '../utils/getAuth0LoginRedirectOptions';
import { getAuth0ReturnTo } from '../utils/getAuth0ReturnTo';
import { useCart } from './useCart';
import { useDecisions } from './useDecisions';
import { usePageLayout } from './usePageLayout';
type SignInCreateAccountButtonProps = Omit<Exclude<ButtonProps, {
  href: string;
}>, 'href'>;
export function SignInCreateAccountButton(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Button data-testid="signInCreateAccount" text="Sign in / Create account" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useAuthSignInClick(returnTo) {
  const $ = _c(14);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    openAccountDrawer
  } = usePageLayout();
  const {
    cart
  } = useCart();
  const isAuth0Enabled = useDecisions("auth0");
  const {
    loginWithRedirect
  } = useAuth0();
  let t0;
  if ($[0] !== pathname || $[1] !== returnTo || $[2] !== searchParams) {
    const search = searchParams?.toString() ?? "";
    t0 = returnTo ?? getAuth0ReturnTo({
      pathname,
      search
    });
    $[0] = pathname;
    $[1] = returnTo;
    $[2] = searchParams;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const resolvedReturnTo = t0;
  const returnToIsImplicit = returnTo === undefined;
  let t1;
  if ($[4] !== cart || $[5] !== isAuth0Enabled || $[6] !== loginWithRedirect || $[7] !== openAccountDrawer || $[8] !== resolvedReturnTo || $[9] !== returnToIsImplicit) {
    t1 = () => {
      if (isAuth0Enabled) {
        return void loginWithRedirect(getAuth0LoginRedirectOptions({
          returnTo: resolvedReturnTo,
          returnToIsImplicit,
          cart
        }));
      }
      openAccountDrawer(AccountDrawerType.SIGN_IN);
    };
    $[4] = cart;
    $[5] = isAuth0Enabled;
    $[6] = loginWithRedirect;
    $[7] = openAccountDrawer;
    $[8] = resolvedReturnTo;
    $[9] = returnToIsImplicit;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const handleSignInClick = t1;
  let t2;
  if ($[11] !== handleSignInClick || $[12] !== isAuth0Enabled) {
    t2 = {
      isAuth0Enabled,
      handleSignInClick
    };
    $[11] = handleSignInClick;
    $[12] = isAuth0Enabled;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}